import { render, staticRenderFns } from "./AsideBarSupportChat.vue?vue&type=template&id=2d0e31c9&scoped=true&"
import script from "./AsideBarSupportChat.vue?vue&type=script&lang=js&"
export * from "./AsideBarSupportChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0e31c9",
  null
  
)

export default component.exports